import { render, staticRenderFns } from "./AdminRemovalDialog.vue?vue&type=template&id=443357b8&"
import script from "./AdminRemovalDialog.vue?vue&type=script&lang=js&"
export * from "./AdminRemovalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports